import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  parseNewUserSearch,
  type NewUserSearch,
} from '../../../../users/new/index.route';

/** Legacy `/admin/users/new` → `/users/new` */
export const Route = createFileRoute(
  '/_private/_route/_internal/admin/users/new/',
)({
  beforeLoad: ({ search }) => {
    throw redirect({
      replace: true,
      search: parseNewUserSearch(search as Record<string, unknown>),
      to: '/users/new',
    });
  },
  validateSearch: (search): NewUserSearch =>
    parseNewUserSearch(search as Record<string, unknown>),
});
